import { CustomDialogModal } from '@shared/components/Dialogs';
import {
  CardMedia,
  Typography,
  Grid,
  CircularProgress,
  Box,
} from '@mui/material';
import Mantenimiento from '@shared/assets/loadingImages/Mantenimiento.gif';
import { useSelector } from 'react-redux';
import { sxStyled } from './styles';

export const LoadingImage = ({ isOpen, site }) => {
  const { site_logos } = useSelector(store => store.pageConfiguration);

  const siteMap = {
    Hoteleria: site_logos.main_loading_image_hot,
    Aereos: site_logos.main_loading_image_fly,
  };

  const imagen = siteMap[site] || site_logos.main_loading_image;

  const styles = sxStyled();

  return (
    <CustomDialogModal
      open={isOpen}
      onClose={() => {}}
      sx={styles.sxDialog}
      showCloseIcon={false}
    >
      {site === 'Spiner' && (
        <Box sx={styles.sxCircularProgress}>
          <CircularProgress />
        </Box>
      )}

      {['Aereos', 'Hoteleria', 'AssistCard'].includes(site) && (
        <CardMedia
          component="img"
          alt="advImage"
          image={imagen}
          sx={styles.getLogoStyle}
        />
      )}

      {site === 'Maintenance' && (
        <>
          <CardMedia
            component="img"
            alt="advImage"
            image={Mantenimiento}
            sx={{ width: 300 }}
          />
          <Grid
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography sx={{ color: 'white', fontSize: 22, fontWeight: 700 }}>
              Disculpe las molestias
            </Typography>
            <Typography sx={{ color: 'white', fontSize: 22, fontWeight: 700 }}>
              Página en mantenimiento
            </Typography>
          </Grid>
        </>
      )}
    </CustomDialogModal>
  );
};

export default LoadingImage;
